// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-primary[data-v-655a994a]{background-color:var(--primary)!important;border-color:var(--primary)!important}.btn[data-v-655a994a]:focus{box-shadow:none!important}input[data-v-655a994a]{display:block}input[data-v-655a994a]:focus{box-shadow:none!important;border-color:var(--primary)!important}", ""]);
// Exports
module.exports = exports;
